/**
 * Configuration Constants
 *
 * Centralized configuration for the MINER application.
 * Modify these values to change network settings, RPC endpoints, etc.
 * This file is completely independent and can be easily updated.
 */

// Solana Network Configuration
export const NETWORK = 'devnet'; // Options: 'devnet', 'testnet', 'mainnet-beta'

// RPC Endpoints with fallbacks
// Primary endpoint is tried first, fallbacks are used if it fails
export const RPC_ENDPOINTS = {
    devnet: [
        'https://api.devnet.solana.com',
        'https://devnet.helius-rpc.com/?api-key=public',
    ],
    testnet: [
        'https://api.testnet.solana.com',
    ],
    'mainnet-beta': [
        'https://api.mainnet-beta.solana.com',
        'https://solana-api.projectserum.com',
    ],
};

// Get current network's RPC endpoints
export const getCurrentRPCEndpoints = () => {
    return RPC_ENDPOINTS[NETWORK] || RPC_ENDPOINTS.devnet;
};

// Mining Configuration
export const MINING_CONFIG = {
    ROUND_DURATION_SECONDS: 60,
    TOTAL_BLOCKS: 25,
    GRID_SIZE: 5,
    MOTHERLODE_CHANCE: 625, // 1 in 625
    MOTHERLODE_INCREMENT: 0.2, // MINER added per round
    TOKENS_PER_ROUND: 1, // MINER distributed per round
    CLAIMING_FEE_PERCENT: 10, // Fee for claiming unrefined MINER
};

// UI Configuration
export const UI_CONFIG = {
    BALANCE_REFRESH_INTERVAL: 10000, // 10 seconds
    TRANSACTION_TIMEOUT: 30000, // 30 seconds
    MIN_SOL_PER_BLOCK: 0.01,
    MAX_SOL_PER_BLOCK: 10,
};

// Transaction Simulation Configuration
export const TRANSACTION_CONFIG = {
    SUCCESS_RATE: 0.95, // 95% success rate for simulated transactions
    MIN_DELAY: 1000, // Minimum delay in ms
    MAX_DELAY: 3000, // Maximum delay in ms
};
